import { jwtDecode } from 'jwt-decode';

export const getTranslatedError = (error: any, t: any): string | undefined =>
  error?.response?.data?.code ? t(`api.errors.${error.response.data.code}`, error.response.data.payload) : error?.response?.data?.message;

export const isZeroPosition = (pos: [number, number]) => pos.every((coordinate) => !coordinate);

export const isBridgeScopedSession = (token: string | null | undefined): boolean => {
  return Boolean(getBridgeScope(token));
};

export const getBridgeScopeShipmentId = (token: string | null | undefined): string | undefined => {
  return getBridgeScope(token)?.shipment_id;
};

export const canGeneratePublicLinkFromSession = (token: string | null | undefined): boolean => {
  const scope = getBridgeScope(token);
  return Boolean(scope && scope.source === 'signed');
};

const getBridgeScope = (token: string | null | undefined): { shipment_id: string; source: 'signed' | 'public' } | undefined => {
  if (!token) return undefined;
  try {
    const decoded = jwtDecode<{ bridge_scope?: { shipment_id?: string; read_only?: boolean; bridge_mode?: boolean; source?: 'signed' | 'public' } }>(token);
    const isBridgeScope = Boolean(
      decoded.bridge_scope?.shipment_id &&
        decoded.bridge_scope.read_only &&
        decoded.bridge_scope.bridge_mode &&
        (decoded.bridge_scope.source === 'signed' || decoded.bridge_scope.source === 'public'),
    );
    if (!isBridgeScope) return undefined;
    return { shipment_id: String(decoded.bridge_scope?.shipment_id), source: decoded.bridge_scope?.source as 'signed' | 'public' };
  } catch {
    return undefined;
  }
};
